import { fetchGuestsUsers, getAllUsers, trackEventsMongo } from '../../util/api';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

export const TRACK_USER_SHOW_REQUEST = 'app/Page/TRACK_USER_SHOW_REQUEST';
export const TRACK_USER_SHOW_SUCCESS = 'app/Page/TRACK_USER_SHOW_SUCCESS';
export const TRACK_USER_SHOW_ERROR = 'app/Page/TRACK_USER_SHOW_ERROR';


export const TRACK_EVENTS_SHOW_REQUEST = 'app/Page/TRACK_EVENTS_SHOW_REQUEST';
export const TRACK_EVENTS_SHOW_SUCCESS = 'app/Page/TRACK_EVENTS_SHOW_SUCCESS';
export const TRACK_EVENTS_SHOW_ERROR = 'app/Page/TRACK_EVENTS_SHOW_ERROR';

export const CLEAR_TRACK_USER = 'app/user/CLEAR_TRACK_USER';

export const GUESTS_USER_SHOW_REQUEST = 'app/Page/GUESTS_USER_SHOW_REQUEST';
export const GUESTS_USER_SHOW_SUCCESS = 'app/Page/GUESTS_USER_SHOW_SUCCESS';
export const GUESTS_USER_SHOW_ERROR = 'app/Page/GUESTS_USER_SHOW_ERROR';

// ================ Reducer ================ //

const initialState = {
    trackUser: null,
    trackUsersInProgress: false,
    trackUserShowError: null,

    trackEvents:null,
    trackEventsInProgress: false,
    trackEventsShowError: null,

    guestsUser: null,
    guestsUsersInProgress: false,
    guestsUserShowError: null,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case TRACK_USER_SHOW_REQUEST:
            return { ...state, trackUsersInProgress: true, trackUserShowError: null };
        case TRACK_USER_SHOW_SUCCESS:
            return { ...state, trackUsersInProgress: false, trackUser:payload };
        case TRACK_USER_SHOW_ERROR:
            // eslint-disable-next-line no-console
            console.error(payload);
            return { ...state, trackUsersInProgress: false, trackUserShowError: payload };


        case TRACK_EVENTS_SHOW_REQUEST:
            return { ...state, trackEventsInProgress: true, trackEventsShowError: null };
        case TRACK_EVENTS_SHOW_SUCCESS:
            return { ...state, trackEventsInProgress: false, trackEvents:payload };
        case TRACK_EVENTS_SHOW_ERROR:
            // eslint-disable-next-line no-console
            console.error(payload);
            return { ...state, trackEventsInProgress: false, trackEventsShowError: payload };

        case CLEAR_TRACK_USER:
            return {
                ...state,
                trackUser: null,
                trackUserShowError: null,
            };


        case GUESTS_USER_SHOW_REQUEST:
            return { ...state, guestsUsersInProgress: true, guestsUserShowError: null };
        case GUESTS_USER_SHOW_SUCCESS:
            return { ...state, guestsUsersInProgress: false, guestsUser: payload };
        case GUESTS_USER_SHOW_ERROR:
            console.error(payload);
            return { ...state, guestsUsersInProgress: false, guestsUserShowError: payload };

        default:
            return state;
    }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const trackUserShowRequest = () => ({ type: TRACK_USER_SHOW_REQUEST });

export const trackUserShowSuccess = user => ({
    type: TRACK_USER_SHOW_SUCCESS,
    payload: user,
});

export const trackUserShowError = e => ({
    type: TRACK_USER_SHOW_ERROR,
    payload: e,
    error: true,
});

export const guestUserShowRequest = () => ({ type: GUESTS_USER_SHOW_REQUEST });

export const guestUserShowSuccess = user => ({
    type: GUESTS_USER_SHOW_SUCCESS,
    payload: user,
});

export const guestUserShowError = e => ({
    type: GUESTS_USER_SHOW_ERROR,
    payload: e,
    error: true,
});

export const trackEventsShowRequest = () => ({ type: TRACK_EVENTS_SHOW_REQUEST });

export const trackEventsShowSuccess = user => ({
    type: TRACK_EVENTS_SHOW_SUCCESS,
    payload: user,
});

export const trackEventsShowError = e => ({
    type: TRACK_EVENTS_SHOW_ERROR,
    payload: e,
    error: true,
});
// ================ Thunks ================ //

// same for unauthenticated users 
export const getGuestsUser = (params) => async (dispatch, getState, sdk) => {
    dispatch(guestUserShowRequest());
    try {
        let page = 1;
        if (typeof params === 'string') {
            page = parseInt(params) || 1;
        } else if (typeof params === 'object') {
            page = params.page || 1;
        }
        const res = await fetchGuestsUsers({ page });
        if (res?.data) {
            dispatch(guestUserShowSuccess(res));
        }

    } catch (error) {
        console.error('Error fetching all users for tracking :', error);
        // You can also dispatch an error action here
    }
};

export const fetchtrackUser = (params) => async (dispatch, getState, sdk) => {
    dispatch(trackUserShowRequest());
    try {
        let page = 1;
        let email = '';
        
        if (typeof params === 'string') {
            page = parseInt(params) || 1;
        } else if (typeof params === 'object') {
            page = params.page || 1;
            email = params.email || '';
        }
        const res = await getAllUsers({ page, email });
        if (res?.data) {
            dispatch(trackUserShowSuccess(res));
        }

    } catch (error) {
        console.error('Error fetching all users for tracking :', error);
        // You can also dispatch an error action here
    }
};

export const fetchTrackEventsFromMongo = (params) => async (dispatch, getState, sdk) => {
    dispatch(trackEventsShowRequest());
    const { userId, deviceId } = params
    try {
        const res = await trackEventsMongo({userId, deviceId})

        if (res?.data) {
            dispatch(trackEventsShowSuccess(res));
        }

    } catch (error) {
        console.error('Error fetching all users for tracking :', error);
        dispatch(trackEventsShowError(error));
    }
};


export const loadData = (params, search, config) => (dispatch, getState) => {
    const queryParams = parse(search, {
        latlng: ['origin'],
        latlngBounds: ['bounds'],
    });
    const { page = 1, email, address, origin, ...rest } = queryParams;
    return Promise.all([
        dispatch(fetchtrackUser({ page: parseInt(page), email })),
        dispatch(getGuestsUser({page: parseInt(page)})),
    ])
};